import React from 'react';
import './Portfolio.css';

const Portfolio = () => {
  const portfolioItems = [
    {
      id: 1,
      title: 'THE AZURE LOFT',
      category: 'Residential • New York',
      video: 'https://videos.pexels.com/video-files/7578546/7578546-uhd_2560_1440_30fps.mp4' 
    },
    {
      id: 2,
      title: 'OAK & STONE',
      category: 'Kitchen • Stockholm',
      video: '/Video2.mp4' 
    },
    {
      id: 3,
      title: 'VELVET HORIZON',
      category: 'Commercial • London',
      video: 'https://videos.pexels.com/video-files/7578552/7578552-uhd_2560_1440_30fps.mp4' 
    },
    {
      id: 4,
      title: 'SERENITY SPA',
      category: 'Wellness • Tokyo',
      video: 'https://videos.pexels.com/video-files/7578546/7578546-uhd_2560_1440_30fps.mp4' 
    },
    {
      id: 5,
      title: 'MINIMALIST HAVEN',
      category: 'Living • Copenhagen',
      video: 'https://videos.pexels.com/video-files/7578552/7578552-uhd_2560_1440_30fps.mp4' 
    },
    {
      id: 6,
      title: 'URBAN RETREAT',
      category: 'Bedroom • Vancouver',
      video: 'Video2.mp4' 
    }
  ];

  return (
    <section id="portfolio" className="portfolio-section">
      <div className="portfolio-header">
        <h2 className="portfolio-title">OUR MASTERPIECES</h2>
        <p className="portfolio-subtitle">Walk through our finest creations</p>
        <div className="title-divider"></div>
      </div>

      <div className="portfolio-grid">
        {portfolioItems.map((item) => (
          <div key={item.id} className="portfolio-card">
            {/* The Video Layer */}
            <div className="video-wrapper">
              <video 
                src={item.video} 
                autoPlay 
                loop 
                muted 
                playsInline /* Important for iOS to allow autoplay */
                className="portfolio-video"
              />
            </div>

            {/* The Overlay Layer (Appears on Hover) */}
            <div className="portfolio-overlay">
              <h3 className="project-title">{item.title}</h3>
              <p className="project-category">{item.category}</p>
              <button className="view-project-btn">VIEW PROJECT</button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Portfolio;